// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  baseUrl: 'https://main.dev.tapgo.ch/app/v1/',
  tenantApi: 'https://tenant.dev.tapgo.ch/app/v1/',

  backupBaseUrl: 'https://main.dev.tapgo.ch/app/v1/',
  backupTenantApi: 'https://tenant.dev.tapgo.ch/app/v1/',
  S3_URL: 'https://sos-ch-dk-2.exo.io/demo-tap-go/',
  production: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
